
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Pipe({
    name: 'signature',
    standalone: true
})
export class SignaturePipe implements PipeTransform {

    constructor(
        private domSanitizer: DomSanitizer
    ) { }

    transform(value: string): SafeUrl {
        return this.getSafeSignature(value);
    }

    public getSafeSignature(signature: string): SafeUrl {

        if (!signature) return null;

        const image = (!signature.startsWith('data:image'))
            ? `data:image/png;base64,${signature}`
            : signature;

        const safeImage = this.domSanitizer.bypassSecurityTrustUrl(image);
        return safeImage;
    }
}